module.exports = __webpack_public_path__ + "static/media/md-checkmark.984edddf.svg";